import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import { ProposalBadge } from "@dreamhub/designsystem/icons";

interface Props {
  onGenerate: () => void;
  isGenerating?: boolean;
  // Why Generate is unavailable; shown on the disabled button.
  blockedReason?: string;
}

export const ProposalsEmptyState: React.FC<Props> = ({
  onGenerate,
  isGenerating = false,
  blockedReason
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="relative flex flex-col items-center justify-center p-8 rounded-2xl border-2 border-dashed border-border-border1 overflow-hidden"
      data-test="proposals-empty-state"
    >
      <div
        aria-hidden
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[258px] h-[172px] rounded-full bg-[color:var(--blue-600)] opacity-[0.12] blur-[60px] pointer-events-none"
      />
      <div className="relative flex flex-col items-center gap-4 w-full">
        <div className="relative w-[59px] h-16" aria-hidden>
          <div className="absolute -left-4 -top-1 w-[91px] h-[97px] [&>svg]:size-full">
            <ProposalBadge />
          </div>
        </div>
        <div className="flex flex-col items-center gap-1 text-center">
          <Text variant="body">{t("contracts.proposals.empty.title")}</Text>
          <Text variant="bodyTertiary">
            {t("contracts.proposals.empty.description")}
          </Text>
        </div>
        <Button
          variant="primary"
          onClick={onGenerate}
          disabled={isGenerating || !!blockedReason}
          tooltipText={blockedReason}
          data-test="proposals-generate"
        >
          {t("contracts.proposals.generate")}
        </Button>
      </div>
    </div>
  );
};
